import React, { useState, useContext } from "react";
import AuthContext from "../../hooks/authContext";
import { Container } from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import { useEffect } from "react";
import confirm from "../../components/DialogComponent/confirm";
import {
  getEmployee,
  setAnyUserData,
  setUserInformation,
} from "../../services/apiservices/employee";
import { Grid } from "@material-ui/core";
import { forgotPasswordAdmin } from "../../services/firebase";
import { CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { handleEmailChange } from "../../services/apiservices/email";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { RefreshCcw, X } from "lucide-react";
import { useToast } from "../../hooks/useToast";
import { CommonConfirmationDialog } from "../../components/DialogComponent/SupplyDataDialog";
import { Link } from "react-router-dom";

const ProfileContainer = (props) => {
  const auth = useContext(AuthContext);
  const profile = auth?.userProfile;
  const [name, setName] = useState();
  const [lname, setLname] = useState();
  const [email, setEmail] = useState();
  const [lEmail, setLEmail] = useState();
  const [phone, setPhone] = useState();
  const [error, setError] = useState(false);
  const [removeRequest, setRemoveRequest] = useState(false);
  const [role, setRole] = useState();
  const [companyName, setCompanyName] = useState();
  const [username, setUsername] = useState();
  const [employeeData, setEmployeeData] = useState(false);
  const [dailogOpen, setDailogOpen] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [emailUpdate, setEmailUpdate] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [alertDailogOpen, setAlertDailogOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const history = useNavigate();
  const { toast } = useToast();
  useEffect(() => {
    getEmployee(
      profile?.id,
      (res) => {
        if (res.status === true) {
          setEmployeeData(res?.data);
        }
      },
      (error) => console.log
    );
  }, [profile?.id]);

  useEffect(() => {
    setName(employeeData?.firstName);
    setLname(employeeData?.lastName);
    setEmail(employeeData?.email);
    setLEmail(employeeData?.email);
    setCompanyName(auth?.userProfile?.role === "companyUser" ? `${employeeData?.companyName}` : `${auth?.userProfile?.companyData?.data?.companyName}`)
    setPhone(employeeData?.phoneNumber ? employeeData?.phoneNumber : employeeData?.phone);
    const roles = Array.isArray(employeeData?.role) ? employeeData.role : [employeeData?.role];
    const displayRole = roles.includes("admin")
      ? "Sys. Admin" : roles.includes("companyUser") ? "Company Manager" : roles.includes("Employee") ? employeeData?.employeerole === "Admin" ? "Team Admin"
      : employeeData?.employeerole || "Employee" : roles[0];
    setRole(displayRole);
    setUsername(employeeData?.userName);
  }, [employeeData]);

  const handleEmailUpdate = (value) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidSequenceRegex =
      /(^[.-])|([.-]$)|(\.{2,})|(\/)|(@\.|\.@)|[^a-zA-Z0-9._%+-@]/;

    const isValidEmail = (email) =>
      emailRegex.test(email) && !invalidSequenceRegex.test(email);

    if (value.trim() === "") {
      setError("Email is required");
      return false;
    }

    if (/\s/.test(value)) {
      setError("Email cannot contain spaces");
      return false;
    }

    if (!isValidEmail(value)) {
      setError("Please enter a valid email address");
      return false;
    }

    setError(false);
    return true;
  };

  const doSaveData = async () => {
    setLoader(true);
    setPhoneError("");

    const isValid = handleEmailUpdate(email);
    if (!isValid) {
      setLoader(false);
      return;
    }

    let data = {
      firstName: name,
      lastName: lname,
      phoneNumber: phone,
    };
    const userId = employeeData?.id;

    let mobileChange = false;
    const phones  = employeeData?.phoneNumber ? employeeData?.phoneNumber : employeeData?.phone

    if(phones !== data?.phoneNumber) {
      mobileChange = true;
    }


    if (email !== lEmail) {
      data.pendingEmail = email;
      data.email = lEmail;
      setEmailUpdate(true);
      handleEmailChange(lEmail, email, data.firstName, userId);
    } else {
      setEmailUpdate(false);
      data.email = email;
    }

    if (!data.firstName || !data.lastName || !data.email) {
      setAlertDailogOpen(true);
      setLoader(false);
      return;
    }

    try {
      const result = await setUserInformation(userId, data, mobileChange);

      if (result.status === true) {
        setDailogOpen(true);
        toast?.({ title: "Success", description: "User information updated successfully." });
      } else if (result.field === "phone") {
        setPhoneError(result.message);
      } else {
        toast?.({ title: "Error", description: result.message || "Failed to update user." });
      }
    } catch (error) {
      console.error("Update error:", error);
      toast?.({ title: "Error", description: error.message || "An unexpected error occurred." });
    } finally {
      setLoader(false);
    }
  };

  const ResetPasswordLink = async () => {
    await forgotPasswordAdmin(
      email,
      phone,
      () => {
        alert("Reset Password Link sent to your Email...");
      }
    );
  };
  const onResetPassword = async () => {
    await confirm(
      "Are you Sure you want to send reset Password Link to your email?"
    ).then(
      () => {
        ResetPasswordLink();
      },
      () => {
        console.log("cancel!");
      }
    );
  };

  const handleResendEmail = () => {
    setEmailUpdate(true);
    setRefresh(true);
    handleEmailChange(employeeData?.email, employeeData?.pendingEmail, name, employeeData?.id);
    setDailogOpen(true);
  }

  const handleCancelRequest = () => {
    setRemoveRequest(false);
  }

  const handleConfirmCancelRequest = async () => {
    setRemoveRequest(false);

    const data = {
      emailChangeOtp: null,
      pendingEmail: null,
    };

    try {
      await setAnyUserData(employeeData?.id, data);
      toast?.({
        title: "Success",
        description: "The email change request has been successfully cancelled.",
      });
      getEmployee(profile?.id, (res) => {
        if (res.status === true) {
          setEmployeeData(res?.data);
        }
      },
      (error) => console.log
    );
    } catch (error) {
      console.error("Error cancelling email change request:", error);
      toast?.({
        title: "Error",
        description: "Failed to cancel the email change request. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleAlertCloseDailog = () => {
    setAlertDailogOpen(false);
  }

  const handleCloseDailog = () => {
    setDailogOpen(false);
    getEmployee(profile?.id, (res) => {
        if (res.status === true) {
          setEmployeeData(res?.data);
        }
      },
    )
  }

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Profile"
          showBreadcrumb={[{ label: "Home", to: "/" }]}
        />

        <div className={`sectionBox dark:bg-[#1A1F2C]`}>
          <div className="profileDetails">
            <div className="stepSectionContent pl-15">
              <h6 className="stepSectionTitle profilet d-flex flex-space-between flex-center dark:border-0">
                <div className="dark:text-white">Personal Information</div>
                {((Array.isArray(auth?.userProfile?.role) && !auth?.userProfile?.role.includes("Employee")) || auth?.userProfile?.role !== "Employee") && (
                  <div style={{ float: "right" }}>
                    <Button
                      variant="contained"
                      className="flatbutton button-danger"
                      onClick={onResetPassword}
                    >
                      Reset password
                    </Button>
                  </div>
                )}
              </h6>
              <Grid item sm={6} md={6}>
                <div className="formFieldwrap mb-40 mt-20">
                  <Label className="dark:text-white">First Name</Label>
                  <Input
                    fullWidth={true}
                    size="small"
                    name="name"
                    id="name"
                    placeholder="First Name"
                    variant="outlined"
                    focused
                    className="mt-8"
                    onChange={(e) => setName(e.target.value)}
                    inputProps={{
                      maxLength: 25,
                      className: "dark:text-white dark:bg-[#1A1F2C] text-black",
                    }}
                    value={name}
                  />
                </div>
                <div className="formFieldwrap mb-40">
                  <Label className="dark:text-white">Last Name</Label>
                  <Input
                    fullWidth={true}
                    size="small"
                    name="lname"
                    id="lname"
                    placeholder="Last Name"
                    variant="outlined"
                    focused
                    className="mt-8"
                    onChange={(e) => setLname(e.target.value)}
                    inputProps={{
                      maxLength: 25,
                      className: "dark:text-white dark:bg-[#1A1F2C] text-black",
                    }}
                    value={lname}
                  />
                </div>
                <div className="formFieldwrap mb-40">
                  <Label className="dark:text-white">Email</Label>
                  <Input
                    fullWidth={true}
                    size="small"
                    name="email"
                    id="email"
                    placeholder="Email"
                    variant="outlined"
                    onChange={(e) => {
                      const value = e.target.value;
                      setEmail(value);
                      handleEmailUpdate(value); // live validation
                    }}
                    focused
                    className="mt-8"
                    inputProps={{
                      maxLength: 50,
                      className: "dark:text-white dark:bg-[#1A1F2C] text-black",
                    }}
                    value={email}
                  />

                  {error && (
                    <p className="mt-8 text-[14px] font-medium text-orange-600 dark:text-orange-600">
                      {error}
                    </p>
                  )}

                  {employeeData?.pendingEmail && (
                    <>
                    <p className="mt-8 text-[14px] font-medium text-orange-600 dark:text-orange-600">
                      To complete your email update, please check your inbox at{" "}
                      <span className="font-semibold ml-4">
                        ({employeeData?.pendingEmail})
                      </span>{" "}
                      to verify your new email address. We will proceed with the update once verification is confirmed.
                      <button
                        type="button"
                        onClick={handleResendEmail}
                        className="ml-5 text-blue-600 underline dark:text-[#16A34A] transition-colors"
                      >
                        Resend
                      </button>
                      <button
                        type="button"
                        onClick={() => setRemoveRequest(true)}
                        className="ml-5 text-blue-600 underline dark:text-[#16A34A] transition-colors"
                      >
                        Cancel this request
                      </button>
                    </p>
                    </>
                  )}
                </div>

                <div className="formFieldwrap mb-40">
                  <Label className="dark:text-white">Mobile Number</Label>
                  <Input
                    fullWidth={true}
                    size="small"
                    name="mobileNumber"
                    id="mobileNumber"
                    placeholder="Mobile Number"
                    variant="outlined"
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setPhone(value);
                    }}
                    focused
                    className="mt-8"
                    inputProps={{
                      maxLength: 25,
                      inputMode: "numeric",
                      className: "dark:text-white dark:bg-[#1A1F2C] text-black",
                    }}
                    value={phone}
                  />
                  {(phoneError && phoneError !== "") &&  (
                    <p className="mt-8 text-[14px] font-medium text-orange-600 dark:text-orange-600">
                        {phoneError}
                      </p>
                  )}
                </div>

                <div className="formFieldwrap mb-40">
                  <Label className="dark:text-white">Role</Label>
                  <Input
                    fullWidth={true}
                    size="small"
                    name="role"
                    id="role"
                    placeholder="Role"
                    variant="outlined"
                    focused
                    className="mt-8"
                    value={role}
                    inputProps={{
                      className: "dark:text-white dark:bg-[#1A1F2C] text-black",
                    }}
                  />
                </div>

                <div className="formFieldwrap mb-40">
                  <Label className="dark:text-white"><p>Company Name (To modify please visit{" "} <Link to="/account/settings/companyPageSetting" className="text-blue-600 hover:!text-blue-800">My Company</Link>{" "}
                      in{" "}<Link to="/account/settings" className="text-blue-600 hover:!text-blue-800">Settings</Link>)</p></Label>
                  <Input
                    fullWidth={true}
                    size="small"
                    name="companyName"
                    id="companyName"
                    placeholder="Company Name"
                    variant="outlined"
                    focused
                    className="mt-8"
                    value={companyName}
                    inputProps={{
                      className: "dark:text-white dark:bg-[#1A1F2C] text-black",
                    }}
                  />
                </div>
                {/* <div className="formFieldwrap mb-40">
                  <Input
                    fullWidth={true}
                    size="small"
                    name="username"
                    id="username"
                    label="UserName"
                    variant="outlined"
                    focused
                    aria-readonly
                    value={username}
                  />
                </div> */}
                <div className="padbtbut">
                  <Button
                    onClick={() => {
                      history("/dashboard");
                    }}
                    variant="outline"
                  >
                    Cancel
                  </Button>

                  <Button
                    className="ml-12"
                    onClick={doSaveData}
                    disabled={loader}
                    variant="default"
                  >
                  {loader ? (
                      <CircularProgress size={20} className="text-white" />
                    ) : (
                      "Save"
                    )}
                  </Button>
                </div>
              </Grid>
            </div>
          </div>
        </div>
      </Container>

      <Dialog open={dailogOpen} onOpenChange={handleCloseDailog}>
        <DialogContent>
          <DialogTitle className="dark:text-white">{emailUpdate ? "Email Address Update" : "Profile Update"}</DialogTitle>
          {emailUpdate ? (
            <div className="text-sm text-gray-600 dark:text-white mt-4 space-y-3">
              <p className="font-semibold">To complete your email address change:</p>
               <ul className="space-y-2 pl-6">
                <li className="flex gap-2">
                  <span className="text-gray-700 dark:text-gray-100 mt-2">•</span>
                  <span>You must still have access to your current email address.</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-gray-700 dark:text-gray-100 mt-2">•</span>
                  <span>
                    You will receive a <span className="font-medium">6 digit code emailed to</span> <span className="font-medium text-blue-500 underline dark:text-blue-400">{employeeData?.email}</span>.
                  </span>
                </li>
                <li className="flex gap-2">
                  <span className="text-gray-700 dark:text-gray-100 mt-2">•</span>
                  <span>
                    You will also receive a <span className="font-medium">verification link to</span>{" "}
                    <span className="font-medium text-blue-500 underline dark:text-blue-400">{employeeData?.pendingEmail || email}</span>.
                  </span>
                </li>
                <li className="flex gap-2">
                  <span className="text-gray-700 dark:text-gray-100 mt-2">•</span>
                  <span>To complete the update, click the link in the verify email and enter the verification code</span>
                </li>
              </ul>
              <p>
                If you don’t have access to both emails, please contact{" "}
                <Link to={"/help/support"} className="text-blue-600 hover:!text-blue-800 text-underLine">ProTeams Support</Link>.
              </p>
            </div>
          ) : (
            <p className="text-sm text-gray-600 dark:text-white mt-8">
              Your profile information has been updated successfully.
            </p>
          )}
          <div className="mt-12 flex justify-end">
            <Button
              onClick={handleCloseDailog}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={alertDailogOpen} onOpenChange={handleAlertCloseDailog}>
        <DialogContent>
          <DialogTitle className="dark:text-white">Alert</DialogTitle>
          <p className="text-sm text-red-600 dark:text-white mt-8">
            Some required fields are missing. Please fill in all fields before saving.
          </p>
          <div className="mt-12 flex justify-end">
            <Button
              onClick={handleAlertCloseDailog}
              className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <CommonConfirmationDialog
        open={removeRequest}
        onClose={handleCancelRequest}
        onConfirm={handleConfirmCancelRequest}
        title={"Email change request cancel"}
        message={"Are you sure you want to cancel this email change request?"}
      />
    </>
  );
};

export default ProfileContainer;
